module.exports = __webpack_public_path__ + "static/media/bg-background-pre-approved.5e0cc8e8.svg";